import { isWeb } from './platformUtils';

export const detectUrlParam = ((param) => {
	if( isWeb ) {
		const url = new URL(window.location.href);
		const urlParam = (url.searchParams && url.searchParams.get(param)) ? url.searchParams.get(param) : '';
		const urlParamTrimmed = urlParam.trim();
		return (param === 'sms' && urlParamTrimmed !== '') ? `+${urlParamTrimmed}` : urlParamTrimmed;
	}
	return '';
});